import { put, call } from 'redux-saga/effects';
import appApi from "../services/appApi";
import { push } from 'connected-react-router';
import { AUTHENTICATE_USER_RESPONSE, AUTHENTICATE_USER_FAILED } from '../redux/types/authenticate';

let api = new appApi();

const dummyAuthenticate = () => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve({ data: { success: true } })
        }, 2000);
    })
}

export function* authenticateUser() {
    let responsePayload = {};
    try {
        let { data } = yield dummyAuthenticate();

        if (data?.success) {

            yield put({ type: AUTHENTICATE_USER_RESPONSE })
        }
        else {
            yield put(push('/'));
            yield put({ type: AUTHENTICATE_USER_FAILED })
        }
    } catch (e) {
        yield put({ type: AUTHENTICATE_USER_FAILED })
    }
}